import {
    LIVE_LIST_API,
    VIDEO_DETAIL,
    DOWNLOAD_RESOURCE,
    LIVE_VIDEO_DETAIL,
    SUBCRIBE_API,
    CHANGE_SUBCRIBE_API,
    CANCEL_SUBCRIBE_API
} from '@constants/api';
import _axios from '@plugins/_axios';
/**
 * 获取直播列表
 */
export function getLiveList() {
    return _axios.post(LIVE_LIST_API);
}

/**
 * 直播预约
 * @param {Number}  schedule_id 直播id
 * @param {Number}  live_id 场次id
 */
export function subcribeLive({ schedule_id, live_id }) {
    return _axios.post(SUBCRIBE_API, {
        schedule_id,
        live_id
    });
}

/**
 * 修改直播预约
 * @param {Number}  schedule_id 直播id
 * @param {Number}  live_id 场次id
 */
export function changeSubcribeLive({ schedule_id, live_id }) {
    return _axios.post(CHANGE_SUBCRIBE_API, {
        schedule_id,
        live_id
    });
}

/**
 * 取消直播预约
 * @param {Number}  schedule_id 直播id
 */
export function cancelSubcribeLive(schedule_id) {
    return _axios.post(CANCEL_SUBCRIBE_API, {
        schedule_id
    });
}

/*
 * 获取视频想详情
 * @param {String} id 计划视频ID
 */
export function getVideoDetail(id) {
    return _axios.post(VIDEO_DETAIL + id);
}
/**
 * 获取直播视频想详情
 * @param {String} id 直播视频ID
 */
export function getLiveVideoDetail(id) {
    return _axios.post(LIVE_VIDEO_DETAIL + id);
}

/**
 * 获取当前计划ID下的资料
 * @param {String} id 计划ID
 */
export function downloadResource(id) {
    return _axios.post(DOWNLOAD_RESOURCE + id);
}
